import { graphql } from "gql";

const INTERNAL_ADMIN_USERS_SET_ACTIVE_MUTATION = graphql(`
  mutation InternalAdminUsersSetActive(
    $organizationId: ID!
    $idList: [ID!]!
    $active: Boolean!
  ) {
    internalAdminUsersSetActive(
      organizationId: $organizationId
      idList: $idList
      active: $active
    ) {
      ...InternalAdminUser
    }
  }
`);

export default INTERNAL_ADMIN_USERS_SET_ACTIVE_MUTATION;
